<template>
  <div>
    <div id="tContentdetalis">
      <div id="cNav">
        <router-link tag="span" :to="{path:'/Homepage'}">首页</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link tag="span"
          :to="{path:'/about/talent'}">招聘</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;职位：
        <span style="color: #FF9900;">{{ tableData.jobs }}</span>
      </div>
      <div style="border-bottom: 1px solid #dedede;">
        <div style="border-bottom: 1px solid #dedede;">
          <span>{{ tableData.jobs }}</span>
          <span>招聘人数：<span style="color: #FF0000;">{{tableData.num}}</span>&nbsp;人</span>
          <span>薪资：{{tableData.salary}}</span>
        </div>
        <div id="contents" v-html="tableData.contents"></div>

      </div>
      <div style="text-align: left;line-height: 40px;">
        <span>上班地址：{{tableData.address}}</span>
      </div>
      <div style="text-align: left;line-height: 40px;">
        <span>联系电话：0971-6111326  （周二至周日）</span>
      </div>
      <div style="text-align: left;margin-top: 20px;"><a class="btn" @click="down">点击下载招聘信息填报表.doc</a></div>
      <div style="clear: both;"></div>
      <div style="height: 40px;line-height: 40px;clear: both;margin-top: 20px;margin-bottom: 20px;">
        <div style="float: right;font-size: 1.2em;">分享到：<div style="float: right;">
            <share :config="config"></share>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import qs from 'qs'
  export default {
    data() {
      return {
        clientHeight: '',
        tableData: [],
        infoid: '',
        loading: false,
        jobs: '',
        config: {
          url: location.href.split("&t=")[0],
          source: "",
          title: decodeURIComponent(this.$route.query.t),
          description: "",
          image: "",
          weiboKey: "",
          wechatQrcodeTitle: "微信扫一扫：分享",
          wechatQrcodeHelper: "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>",
          wechatQrcodeSize: 100,
          sites: ["weibo", "qq", "wechat"],
          mobileSites: [],
          disabled: [],
          initialized: !1
        },
        fileList: [],
        addForm: {
          talentid: "",
          urls: ""
        }
      }
    },
    mounted() {
      this.handleSearch();
      $("body,html").animate({
        scrollTop: 0
      }, 1);
    },
    methods: {
      handleSearch() {
        this.search();
      },
      // 查询列表
      search: function() {
        let that = this;
        let url = this.HOST + '/api/v1/talent/talentOne/' + this.$route.query.id + '';
        this.loading = true;
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.tableData = cData.data;
        }).catch(function(error) {
          console.log(err);
        })
      },
      down: function() {
        let fileName = "http://www.qhmuseum.cn/qhm-webapi/upload/zp/招聘信息表.doc" // 文件地址
        let downName = "报名信息表.doc" // 文件下载名称
        const blob = new Blob([fileName])
        if (window.navigator.msSaveOrOpenBlob) {
          // 兼容IE10
          navigator.msSaveBlob(blob, downName)
        } else {
          let aTag = document.createElement('a')
          aTag.setAttribute("href", fileName);
          aTag.setAttribute("download", "");
          aTag.click()
        }
      },
      addSubmit: function() {
        let that = this;
        let url = this.HOST + '/talent/editdoc';
        this.$refs.upload.clearFiles();
        that.loading = true;
        this.addForm.talentid = this.$route.query.id;
        let para = Object.assign({}, this.addForm);
        if (this.addForm.urls != "") {
          that.$axios.post(url, qs.stringify(para)).then(function(result) {
            if (result.data.data.status = "ok") {
              that.$notify.success({
                showClose: true,
                title: '上传成功',
                message: '招聘信息表以上传成功',
                duration: 2000
              });
              that.$refs['addForm'].resetFields();
              that.addFormVisible = false;
              that.search();
            } else {
              that.$message.error({
                showClose: true,
                message: '上传失败',
                duration: 2000
              });
            }
          }, function(err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }).catch(function(error) {
            console.log(error)
          })
        } else {
          that.$notify.error({
            showClose: true,
            title: '上传失败',
            message: '请上传文件',
            duration: 2000
          });
        }

      },
    }
  }
</script>

<style scoped>
  #tContentdetalis {
    width: 70%;
    margin-right: 15%;
    margin-left: 15%;
    height: 100%;
  }

  #contents{
    font-size: 18px;
    line-height: 40px;
    padding-top: 1.25rem;
  }

  #tContentdetalis>#cNav {
    text-align: left;
    height: 48px;
    line-height: 48px;
  }

  #tContentdetalis>#cNav>span:nth-child(1),
  #tContentdetalis>#cNav>span:nth-child(2) {
    cursor: pointer;
  }

  #tContentdetalis>#cNav>span:nth-child(1):hover,
  #cContentdetials>#cNav>span:nth-child(2):hover {
    color: #FF9900;
  }

  #tContentdetalis>div:nth-child(2)>div:nth-child(1) {
    line-height: 40px;
    text-align: left;

  }

  #tContentdetalis>div:nth-child(2)>div:nth-child(1)>span:nth-child(1) {
    font-size: 20px;
    font-weight: 600;
  }

  #tContentdetalis>div:nth-child(2)>div:nth-child(1)>span:nth-child(2) {
    font-size: 16px;
    margin-left: 50px;
  }

  #tContentdetalis>div:nth-child(2)>div:nth-child(1)>span:nth-child(3) {
    font-size: 16px;
    margin-left: 30px;
  }

  #tContentdetalis>div:nth-child(2)>div:nth-child(2) {
    text-align: left;
    line-height: 30px;
  }

  .btn {
    color: #0066CC;
    cursor: pointer;
  }

  .btn:hover {
    color: #0000FF;
  }
</style>



// WEBPACK FOOTER //
// src/pages/about/talentdetials/talentdetials.vue